import { Message } from '../../shared/models/system/message';
import { Globals } from '../../shared/services/globals';
import { GenericVm } from 'src/app/shared/models/system/generic-vm';
import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { MessageEnum } from 'src/app/shared/models/system/message.enum';
import { TranslateService } from '@ngx-translate/core';



@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private httpRes: HttpRequestService, private globals: Globals, private translate: TranslateService) { }
  }




























